import * as React from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import Input from "../components/Input";
import bg from "../assets/images/wall.jpg";
import { IFormSignUp } from "../types/IAuth";
import { registerUser } from "../api/AuthService";
import { toast } from "react-toastify";
import "tippy.js/dist/tippy.css";
import { CASE, useAuthContext } from "../context/useAuthContext";
import { Link, useNavigate } from "react-router-dom";
import useDisabled from "../hooks/useDisabled";
import { LoadingButton } from "../components/Loading";

const backgroundImageStyle = {
  backgroundImage: `url(${bg})`,
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  width: "100vw",
};
export default function SignUpPage() {
  const { dispatch: dispatchAction, state } = useAuthContext();
  const navigate = useNavigate();
  const signupFormik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Full name is required!"),
      email: Yup.string()
        .email("Invalid email!")
        .required("Email is required!"),
      password: Yup.string()
        .required("Password is required!")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          "Password must be at least 8 characters long and include uppercase, lowercase, numbers, and special characters!"
        ),
    }),
    onSubmit: async (values) => {
      try {
        if (!values) {
          return;
        }
        const { fullName, email, password } = values;
        const newUser: IFormSignUp = {
          fullName,
          email,
          password,
        };
        const response = await registerUser(newUser);
        if (response.data.status === "success") {
          console.log(response.data);
          dispatchAction({ type: CASE.SIGN_UP, payload: response?.data?.user });
          toast.success(`Sign up successfully!`, {
            position: "top-center",
          });
          signupFormik.resetForm();
          navigate("/");
        }
      } catch (error: any) {
        toast.error(error?.response?.data, {
          position: "top-center",
          autoClose: 1500,
        });
      }
    },
    validateOnBlur: false,
    validateOnChange: false,
  });
  const { disabledStyle, isDisabled } = useDisabled(signupFormik.isSubmitting);
  return (
    <div
      style={backgroundImageStyle}
      className="inset-0 bg-white relative  bg-signup gap-x-5"
    >
      <div className="absolute px-10 left-10 top-5  py-10">
        <div></div>
      </div>
      <div className="wrapper-layout section">
        <div className="flex h-screen justify-center items-center">
          <div className="m-auto z-50 p-4 modal-signup bg-timerBg  border border-bordermood w-[400px] rounded-lg">
            <form
              className="form-signup flex flex-col gap-y-3"
              onSubmit={signupFormik.handleSubmit}
            >
              <div className="form-field">
                <Input
                  id="fullName"
                  data={signupFormik.values.fullName}
                  setData={signupFormik.handleChange}
                  placeholder="full name"
                  error={signupFormik.errors.fullName}
                />
              </div>

              <div className="form-field">
                <Input
                  id="email"
                  data={signupFormik.values.email}
                  setData={signupFormik.handleChange}
                  placeholder="Email"
                  error={signupFormik.errors.email}
                />
              </div>

              <div className="form-field">
                <Input
                  id="password"
                  data={signupFormik.values.password}
                  setData={signupFormik.handleChange}
                  placeholder="Password"
                  error={signupFormik.errors.password}
                />
              </div>

              <button
                type="submit"
                disabled={isDisabled}
                style={disabledStyle}
                className="text-white h-9 opacity-50 hover:opacity-100 transition-all bg-primary px-3 py-1 text-base  rounded-md"
              >
                {isDisabled ? <LoadingButton /> : <span>Sign up</span>}
              </button>
            </form>
            <div className="flex text-sm italic mt-4 items-center gap-x-2">
              <span className="text-white">
                Do you already have an account?
              </span>
              <Link
                className="text-primary  italic underline text-sm font-normal cursor-pointer"
                to={"/sign-in"}
              >
                Sign in
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
